// standard common error messages
export const SERVER_ERROR = "🔴 Server error"
export const NOT_FOUND = "🔴 Resource not found"